















import { IQuoteProjectSize } from '@/models/quote';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'QuoteProjectSizeDisplay',

  props: {
    size: { type: Object as PropType<IQuoteProjectSize>, required: true }
  },
});
